import { Container, ListGroup, Spinner } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

function Noha() {
  const [nohey, setNohey] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllNohey = async () => {
      try {
        let allPosts = [];
        let page = 1;
        let totalPages = 1;

        do {
          const res = await fetch(
            `http://bayazegham.in/wp-json/wp/v2/posts?categories=4&per_page=100&page=${page}&_fields=title,link`
          );

          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

          const data = await res.json();

          totalPages = parseInt(res.headers.get("X-WP-TotalPages"), 10);

          const mappedData = data.map(post => ({
            title: post.title.rendered,
            url: post.link
          }));

          allPosts = [...allPosts, ...mappedData];
          page++;
        } while (page <= totalPages);

        setNohey(allPosts.sort((a, b) => a.title.localeCompare(b.title)));
        setLoading(false);
      } catch (error) {
        console.error("Error fetching posts:", error);
        setLoading(false);
      }
    };

    fetchAllNohey();
  }, []);

  const filteredNohey = nohey.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <Container>
      <div className='mt-3'>
        <input
          type='text'
          className='form-control w-100'
          placeholder='Type Your Search'
          onChange={(e) => setSearch(e.target.value)}
          value={search}
        />
      </div>

      <h3 className='mt-2'>Select a Noha to Recite</h3>
      </Container>

      {loading ? (
        <div className="text-center mt-3">
          <Spinner animation="border" variant="dark" />
        </div>
      ) : (
        <ListGroup className='mt-3'>
          <AnimatePresence>
            {filteredNohey.map((item, i) => (
              <motion.div
                key={item.url}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <ListGroup.Item action href={item.url} target="_blank">
                  {item.title}
                </ListGroup.Item>
              </motion.div>
            ))}
          </AnimatePresence>
          <div className="mt-3 text-muted">
            Total Nohey: {filteredNohey.length}
          </div>
        </ListGroup>
      )}
    </div>
  );
}

export default Noha;
